import { render, staticRenderFns } from "./SideNavLink.vue?vue&type=template&id=c0553358&scoped=true&"
import script from "./SideNavLink.vue?vue&type=script&lang=js&"
export * from "./SideNavLink.vue?vue&type=script&lang=js&"
import style0 from "./SideNavLink.vue?vue&type=style&index=0&id=c0553358&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0553358",
  null
  
)

export default component.exports